var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroModalMacIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_132_1",
    "data-name": "Component 132 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.015,
    height: 31.465,
    viewBox: "0 0 27.015 31.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M231.758,43.317a8.261,8.261,0,0,1,4.088-1.827,7.738,7.738,0,0,1-1.471,5.018,6.4,6.4,0,0,1-5.035,2.648A6.981,6.981,0,0,1,231.758,43.317Z",
    transform: "translate(-216.411 -41.49)",
    fill: "#7db22f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M188,72.051a7.857,7.857,0,0,1,6.728-3.97c1.816-.1,3.427.846,5.144,1.244,1.847.4,3.41-.936,5.184-1.135a7.557,7.557,0,0,1,5.01.762,12.244,12.244,0,0,1,2.634,2.2l-1.295.913C203.6,72.068,195.8,72.1,188,72.051Z",
    transform: "translate(-186.665 -60.625)",
    fill: "#7db22f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M184.544,82.27h.073c7.8.05,15.6.017,23.405.017a7.356,7.356,0,0,0-2.225,3.984h-.039c-7.487-.064-14.971-.006-22.458-.031A13.425,13.425,0,0,1,184.544,82.27Z",
    transform: "translate(-183.283 -70.844)",
    fill: "#ffc60d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M183.254,96.438c7.487.025,14.971-.034,22.458.031a10.317,10.317,0,0,0,.516,3.959c-7.621-.062-15.243-.017-22.864-.022A29.748,29.748,0,0,1,183.254,96.438Z",
    transform: "translate(-183.237 -81.041)",
    fill: "#fe8a1a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M183.69,110.573c7.621.006,15.243-.039,22.864.022a8.985,8.985,0,0,0,4.024,3.867c-.062,0-.188.006-.249.008-8.518.1-17.039.059-25.557.02A20.464,20.464,0,0,1,183.69,110.573Z",
    transform: "translate(-183.563 -91.208)",
    fill: "#df2d21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M187.55,124.53c8.518.039,17.039.081,25.557-.02a18.227,18.227,0,0,1-2.236,4.169c-7.041-.07-14.08.022-21.119-.045A16.792,16.792,0,0,1,187.55,124.53Z",
    transform: "translate(-186.342 -101.248)",
    fill: "#a7286b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M195.41,139.23c7.039.067,14.077-.025,21.119.045-1.23,1.729-2.687,3.721-4.954,4.007-1.65.241-2.878-1.224-4.483-1.258a7.185,7.185,0,0,0-3.727.446,5.289,5.289,0,0,1-3.561.737C197.82,142.629,196.436,140.931,195.41,139.23Z",
    transform: "translate(-191.999 -111.843)",
    fill: "#00a2d5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroModalMacIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroModalMacIcon.bd23580558edd9147b86e58236f5515d.svg";
export { ForwardRef as ReactComponent };